import { render } from "./FileXmlView.vue?vue&type=template&id=5e7a3f4c&scoped=true"
import script from "./FileXmlView.vue?vue&type=script&lang=js"
export * from "./FileXmlView.vue?vue&type=script&lang=js"

import "./FileXmlView.vue?vue&type=style&index=0&id=5e7a3f4c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e7a3f4c"]])

export default __exports__